export const CURRENCY = {
  rub: 'RUB',
  usd: 'USD',
  eur: 'EUR',
};
